export default __webpack_public_path__ + "static/industry-25d20925e4c738d7dfa20ec11d7340db.png";